import { ShareConfigItemTypeEnum, ShareConfigItem } from './types'
import openQrcode from '@/modules/marketing/activity/component/qrcode'
import openShareMask from '@/modules/marketing/activity/component/shareMask'

import util from '@/common/util'

export const defaultShareConfig: ShareConfigItem[] = [
  {
    type: ShareConfigItemTypeEnum.WX,
    title: '微信好友',
    icon: require('./icon/share-icon__wx.png'),
    onClick: openShareMask
  },
  {
    type: ShareConfigItemTypeEnum.PYQ,
    title: '微信朋友圈',
    icon: require('./icon/share-icon__pyq.png'),
    onClick: openShareMask
  },
  {
    type: ShareConfigItemTypeEnum.Copy,
    title: '复制链接',
    icon: require('./icon/share-icon__copy.png'),
    onClick: (options) => {
      copyRoles(options.own_url)
    }
  },
  {
    type: ShareConfigItemTypeEnum.Qrcode,
    title: '专属二维码',
    icon: require('./icon/share-icon__qrcode.png'),
    onClick: (options) => {
      openQrcode({ own_url: options.own_url })
    }
  }
]

// 创建容器复制
const copyRoles = (data: string, onSuccess?: () => void, onFail?: () => void) => {
  const inputIdName = 'clipBoard'
  const appElement = document.getElementById('app') as HTMLElement
  const input = document.createElement('input') as HTMLInputElement
  input.id = inputIdName
  input.value = data
  input.readOnly = true
  appElement.appendChild(input)
  let eleSelect = document.querySelector('#clipBoard') as HTMLInputElement
  selectText(eleSelect, 0, data.length)
  if (document.execCommand('copy')) {
    document.execCommand('copy')
    onSuccess && onSuccess()
    util.showToast('已复制，去分享吧')
  } else {
    onFail && onFail()
    util.showToast('复制失败')
  }
  eleSelect.blur()
  appElement.removeChild(input)
}

// 选中文字
const selectText = (textBox: any, startIndex: number, stopIndex: number) => {
  const { createTextRange } = textBox
  if (!createTextRange) {
    textBox.setSelectionRange(startIndex, stopIndex)
    textBox.focus()
    return
  }
  const range = textBox.createTextRange()
  range.collapse(true)
  range.moveStart('character', startIndex)// 起始光标
  range.moveEnd('character', stopIndex - startIndex)// 结束光标
  range.select()
}
